import {
  CREATE_SELLER_REPLACEMENT,
  CREATE_SELLER_REPLACEMENT_SUCCESS,
  CREATE_SELLER_REPLACEMENT_ERROR,
  UPDATE_SELLER_REPLACEMENT,
  UPDATE_SELLER_REPLACEMENT_SUCCESS,
  UPDATE_SELLER_REPLACEMENT_ERROR,
  SEARCH_SELLER_REPLACEMENTS,
  SEARCH_SELLER_REPLACEMENTS_SUCCESS,
  SEARCH_SELLER_REPLACEMENTS_ERROR,
  GET_ACTIVE_REPLACEMENT,
  GET_ACTIVE_REPLACEMENT_SUCCESS,
  GET_ACTIVE_REPLACEMENT_ERROR,
  CLEAR_SELLER_REPLACEMENTS_STATE,
} from '../constants/ActionsTypes'

export const createSellerReplacement = (params) => {
  return {
    type: CREATE_SELLER_REPLACEMENT,
    payload: params,
  }
}

export const createSellerReplacementSuccess = (data) => {
  return {
    type: CREATE_SELLER_REPLACEMENT_SUCCESS,
    payload: data,
  }
}

export const createSellerReplacementError = (error) => {
  return {
    type: CREATE_SELLER_REPLACEMENT_ERROR,
    payload: error,
  }
}

export const updateSellerReplacement = (params) => {
  return {
    type: UPDATE_SELLER_REPLACEMENT,
    payload: params,
  }
}

export const updateSellerReplacementSuccess = (data) => {
  return {
    type: UPDATE_SELLER_REPLACEMENT_SUCCESS,
    payload: data,
  }
}

export const updateSellerReplacementError = (error) => {
  return {
    type: UPDATE_SELLER_REPLACEMENT_ERROR,
    payload: error,
  }
}

export const searchSellerReplacements = (params) => {
  return {
    type: SEARCH_SELLER_REPLACEMENTS,
    payload: params,
  }
}

export const searchSellerReplacementsSuccess = (data) => {
  return {
    type: SEARCH_SELLER_REPLACEMENTS_SUCCESS,
    payload: data,
  }
}

export const searchSellerReplacementsError = (error) => {
  return {
    type: SEARCH_SELLER_REPLACEMENTS_ERROR,
    payload: error,
  }
}

export const getActiveReplacement = (telemarketerId) => {
  return {
    type: GET_ACTIVE_REPLACEMENT,
    payload: telemarketerId,
  }
}

export const getActiveReplacementSuccess = (data) => {
  return {
    type: GET_ACTIVE_REPLACEMENT_SUCCESS,
    payload: data,
  }
}

export const getActiveReplacementError = (error) => {
  return {
    type: GET_ACTIVE_REPLACEMENT_ERROR,
    payload: error,
  }
}

export const clearSellerReplacementsState = () => {
  return {
    type: CLEAR_SELLER_REPLACEMENTS_STATE,
  }
}
